import { useScrollReveal } from "@/hooks/use-scroll-reveal"

export function ScrollReveal({
  children,
  className = "",
  stagger = false,
}: {
  children: React.ReactNode
  className?: string
  stagger?: boolean
}) {
  const ref = useScrollReveal()
  return (
    <div
      ref={ref}
      className={`scroll-reveal ${stagger ? "scroll-reveal-stagger" : ""} ${className}`}
    >
      {children}
    </div>
  )
}
